import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link as RouterLink } from 'react-router-dom';
import { composePageTitle } from './Common';
import Footer from './components/Footer';
import Header from './components/Header';
import Application from './config/application';
import { PageUrl } from './Constants';

const Terms = () => {
    return (
        <div id="main-wrapper">
            <Helmet title={composePageTitle('Terms and Conditions')} />
            <Header />
            <section className="page-header page-header-dark bg-secondary">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-md-8">
                            <h1>Terms and Conditions</h1>
                        </div>
                        <div className="col-md-4">
                            <ul className="breadcrumb justify-content-start justify-content-md-end mb-0">
                                <li>
                                    <RouterLink to={PageUrl.HOME}>Home</RouterLink>
                                </li>
                                <li className="active">Terms and Conditions</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>
            <div id="content">
                <div className="container">
                    <div className="bg-white shadow-md rounded p-4 mb-4">
                        <div>
                            <h4 className="top-gap"> BOOKING CONDITIONS </h4>
                            <p className="about_txt">Welcome to the   {Application.ORG_DISPLAY_NAME} website (the “Site”), operated by   {Application.ORG_DISPLAY_NAME} (“we,” “us,” or “our”). This Site is intended to help users access travel-related information, check availability, make reservations, and conduct other travel-related transactions.</p>
                            <p className="about_txt">
                                By using this Site—whether browsing, making bookings online or by phone, or interacting with any part of the Site—you agree to be bound by these Terms & Conditions. If you do not agree, you must not use the Site. These Terms are subject to change without notice, and updated versions take effect immediately upon posting. Continued use indicates your acceptance of any revisions. Please review this page regularly to stay informed of changes.

                            </p>

                            <h4 className='top-gap'>Acceptance of Terms and Privacy Policy</h4>
                            <p className="about_txt">
                                Use of the Site also means you accept our [Privacy Policy], which is incorporated into these Terms. Do not use the Site if you do not agree to both.
                            </p>

                            <h4 className='top-gap'>Eligibility</h4>

                            <p className="about_txt">
                                The Site is intended for users who are at least 18 years old and residents of the United States, its territories, or Canada. By using the Site, you confirm that you meet these requirements. If you do not, you are not authorized to use the Site.

                            </p>

                            <h4 className="top-gap">
                                {' '}
                                <strong> User Representation </strong>
                                {' '}
                            </h4>
                            <p>
                                By using the Site, you confirm that:
                            </p>
                            <ul>
                                <li>You are at least 18 years of age.</li>
                                <li>
                                    All information you provide is accurate and complete.
                                </li>
                                <li>
                                    All information provided by you is true, accurate, and complete.
                                </li>
                                <li>You are using the Site for personal purposes, such as booking travel for yourself or others.</li>
                            </ul>
                            <p>
                                {Application.ORG_DISPLAY_NAME} may request documentation to verify bookings and reserves the right to cancel reservations if verification is not provided.

                            </p>



                            <h4 className="top-gap">
                                {' '}
                                <strong>Changes to Terms </strong>
                                {' '}
                            </h4>
                            <p>
                                We may modify these Terms at any time. All changes are effective immediately when posted and apply to future use of the Site. You are responsible for reviewing the Terms regularly. Continued use of the Site after changes means you accept the updated Terms.
                            </p>

                            <h2>Mobile App License</h2>
                            <p> We grant you a limited, non-transferable, non-exclusive license to:</p>
                            <ul>
                                <li>
                                    Download and use our app on a single device for personal, non-commercial use.
                                </li>
                                <li>
                                    Access app content and services as permitted by these Terms.
                                </li>
                            </ul>

                            <p>
                                The app is licensed—not sold—and all rights not expressly granted remain with   {Application.ORG_DISPLAY_NAME} and its licensors.
                            </p>


                            <h2>App Updates</h2>
                            <p className="about_txt">
                                Updates may include enhancements, fixes, or features and may install automatically or require your action. The app may not function properly without current updates, which are governed by these Terms.
                            </p>

                            <h2>
                                {' '}
                                Export Compliance and U.S. Government Use
                            </h2>
                            <p className="about_txt">
                                You agree not to export the app in violation of U.S. law. If used by the U.S. government, rights are limited to those specified in applicable regulations.
                            </p>

                            <h2>
                                {' '}
                                Access and Account Security
                            </h2>
                            <p className="about_txt">
                                We may limit or terminate Site access at any time and are not liable for any disruptions. You are responsible for your login credentials and any activity on your account. Notify us immediately of any unauthorized access. We may disable accounts for any violation of these Terms.

                            </p>

                            <h2>
                                {' '}
                                Intellectual Property
                            </h2>
                            <p className="about_txt">
                                All content on the Site—including design, images, software, and text—is the property of   {Application.ORG_DISPLAY_NAME} or its licensors and is protected by law. You may:
                            </p>
                            <ul>
                                <li>View content through your browser.</li>
                                <li>
                                    Print one copy for personal use.
                                </li>
                                <li>
                                    Download only if explicitly allowed under a license.
                                </li>
                            </ul>

                            <p>You may not:</p>
                            <ul>
                                <li>Reproduce, republish, or use content for commercial purposes.</li>
                                <li>
                                    Remove copyright or trademark notices.
                                </li>
                                <li>
                                    Use content in any way not authorized by these Terms.
                                </li>

                            </ul>
                            <p>
                                Violation of these conditions ends your right to use the Site.</p>

                            <h2>Trademarks</h2>
                            <p>
                                All trademarks and logos on the Site are the property of  {Application.ORG_DISPLAY_NAME} or third parties. You may not use them without prior written permission.
                            </p>

                            <h2>Prohibited Uses</h2>
                            <p> You agree not to use the Site for any unlawful or prohibited activity, including but not limited to:</p>
                            <ul>
                                <li>Violating laws or regulations.</li>
                                <li>
                                    Exploiting or harming minors.
                                </li>
                                <li>
                                    Sending spam or unsolicited promotions.
                                </li>
                                <li>
                                    Impersonating others.
                                </li>
                                <li> Disrupting the Site’s functionality or systems.</li>
                                <li> Using bots, malware, or denial-of-service tactics.</li>
                                <li> Gaining unauthorized access to systems.</li>
                            </ul>

                            <h2>User Content</h2>
                            <p>
                                The Site may allow users to post content ("User Contributions"). By posting, you grant us a license to use and distribute your content. You represent that you own or have rights to your content and that it complies with these Terms. We are not responsible for user-generated content and disclaim any liability arising from it.
                            </p>

                            <h2>Monitoring and Enforcement</h2>
                            <p>We reserve the right to:</p>
                            <ul>
                                <li>Remove or refuse any content.</li>
                                <li>
                                    Take action against violators.
                                </li>
                                <li>
                                    Cooperate with law enforcement.
                                </li>
                                <li>Terminate access as needed.</li>
                            </ul>
                            <p>We do not guarantee the timely removal of harmful content.</p>

                            <h2>Content Standards</h2>
                            <p> User Contributions must not:</p>
                            <ul>
                                <li>Contain offensive or illegal material.</li>
                                <li>
                                    Promote hate, violence, or discrimination.
                                </li>
                                <li>
                                    Infringe on others’ rights.
                                </li>
                                <li>Impersonate or mislead.</li>
                                <li>Include commercial promotions.</li>
                                <li>Misrepresent affiliation or endorsement.</li>
                            </ul>
                            <p>Violations may result in legal action or termination of access.</p>


                            <h2>User Responsibilities</h2>
                            <p>You agree to:</p>
                            <ul>
                                <li>Provide truthful and accurate booking information.</li>
                                <li>
                                    Protect your login credentials.
                                </li>
                                <li>
                                    Avoid unlawful, fraudulent, or malicious use of the Site.

                                </li>
                                <li>Not redistribute Site content.</li>
                            </ul>

                            <h2>Third-Party Links</h2>
                            <ul>
                                <li>We may display third-party content or links for your convenience. {Application.ORG_DISPLAY_NAME} does not endorse or control third-party sites and is not responsible for their practices or content.</li>

                            </ul>

                            <h2>Booking Terms</h2>
                            <ul>
                                <li> Flight details are subject to airline changes or cancellations.</li>
                                <li> Prices may vary until payment is confirmed.</li>
                                <li> Promotional offers apply only to service fees and cannot be combined with others</li>
                            </ul>

                            <h2>Disclaimers</h2>
                            <ul>
                                <li> We do not guarantee the accuracy of travel information, prices, or availability. We are not liable for:
                                    <ul>
                                        <li>Technical issues or delays.</li>
                                        <li>Third-party provider actions (e.g., cancellations, bankruptcies).</li>
                                        <li> Risks associated with international travel.</li>
                                    </ul>
                                </li>

                            </ul>

                            <h2>Limitation of Liability</h2>
                            <p>To the fullest extent permitted by law, {Application.ORG_DISPLAY_NAME} and affiliates are not liable for:</p>
                            <ul>
                                <li> Indirect, incidental, or consequential damages (e.g., lost profits or data).</li>
                                <li> Issues caused by third-party services.</li>
                            </ul>

                            <h2>Arbitration Agreement</h2>
                            <p>All disputes related to your use of the Site must be resolved through binding arbitration (not in court) and on an individual basis. No class actions are permitted. Arbitration will follow AAA rules and take place in [Specify Jurisdiction].</p>

                            <h2>Governing Law</h2>
                            <p>These Terms are governed by the laws of [Specify State/Country], without regard to conflict-of-law principles.</p>

                            <h2>Modifications</h2>
                            <p>We may revise these Terms at any time. Continued use of the Site after changes indicates your acceptance.</p>

                            <h2>Disclaimer for Free Services</h2>
                            <p>
                                If the Site and its services are offered free of charge, we are not liable for any loss or damage of any kind resulting from their use.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default Terms;
